import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes, SortingDirection } from "enums";
import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";

// Initial filter state for external links overview
export const initialState: FiltersState<string> = {
  filterOptions: {},
  appliedFilter: {},
  search: "",
  pagination: 1,
  sortingColumnName: "added",
  sortingDirection: SortingDirection.Descending,
  shouldSort: true,
  isLoading: false,
  error: undefined,
};

const externalLinksFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ExternalLinks,
    name: "OverviewFilters",
  },
  initialState,
  reducers: {
    // Optional override to set sorting direction from API strings
    setPlainSortingDirection: (state, action: PayloadAction<string>) => {
      state.sortingDirection =
        action.payload.toLowerCase() === "desc" ? SortingDirection.Descending : SortingDirection.Ascending;
    },
  },
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setPagination,
  resetPagination,
  setSortingColumnName,
  resetSortingColumnName,
  setSortingDirection,
  setPlainSortingDirection,
  resetSortingDirection,
  resetFilter,
  resetShouldSort,
  setShouldSort,
} = externalLinksFiltersSlice.actions;

export default externalLinksFiltersSlice.reducer;
